import React, { useState, useEffect } from "react";
import "../style.css";

export const Frame = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const isProduction = process.env.REACT_APP_NODE_ENV === "production";

  // Conditionally set the path based on the environment
  const imagePath = isProduction
    ? window.location.hostname.includes("localhost")
      ? "../"
      : "https://www.directmortgage.com/R/"
    : "../";

  const fnGoToHome = async () => {
    window.location.href = "https://www.directmortgage.com";
  };

  const fnGoToLogin = async () => {
    window.location.href = "https://www.directmortgage.com/sitelogin/";
  };

  const fnMenuItems = async (GoTo) => {
    if (GoTo == 1)
      window.location.href = "https://www.directmortgage.com/home-loans/";

    if (GoTo == 2)
      window.location.href =
        "https://www.directmortgage.com/wholesale/wholesaleresources/";

    if (GoTo == 3) window.location.href = "https://www.directmortgage.com";

    if (GoTo == 4)
      window.location.href = "https://www.directmortgage.com/sitelogin/";
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };
  useEffect(() => {
    // Add event listener to update state on window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="frame container">
      <div className="directmortgagetrans-wrapper">
        <img
          className="directmortgagetrans"
          alt="Directmortgagetrans"
          src={`${imagePath}NewAppLogo.png`}
          style={{ cursor: "pointer" }}
          onClick={() => fnMenuItems(3)}
        />
      </div>
      <div className="icon-menu">
        <div
          className="text-wrapper"
          style={{ cursor: "pointer" }}
          onClick={() => fnMenuItems(3)}
        >
          Home
        </div>
        <div
          className="text-wrapper"
          style={{ cursor: "pointer" }}
          onClick={() => fnMenuItems(1)}
        >
          Loans
        </div>
        <div
          className="text-wrapper"
          style={{ cursor: "pointer" }}
          onClick={() => fnMenuItems(2)}
        >
          Resources
        </div>
        <div className="div-wrapper">
          <div
            className="div"
            style={{ cursor: "pointer" }}
            onClick={() => fnMenuItems(4)}
          >
            Login
          </div>
        </div>
      </div>
    </div>
  );
};
